import BadgeUserPendingCertification from '../BadgeUserPendingCertification';
import PhotoVerificationItemCard from '../PhotoVerificationItemCard';
import { isCertified, isCertifPending } from '@/lib/utils.ts';
import { PhotoGridPositionsEnum } from '@/lib/enum.ts';
import BadgeUserCertified from '../BadgeUserCertified';
import { TProps } from '.';

const UserPhotoGridCertification = ({ cardClassName, userData, withButtons = true }: Pick<TProps, 'cardClassName' | 'userData' | 'withButtons'>) => {

	const hasPendingCertification = isCertifPending(userData?.verifications);
	const hasCertification = isCertified(userData?.verifications);

	if (!userData?.verifications?.id?.photo) {
		return <></>;
	}

	return (
		<div className='relative'>
			<PhotoVerificationItemCard
				withButtons={withButtons}
				userId={userData._id}
				className={cardClassName}
				picture={{
					status: userData.verifications.id.status,
					position: PhotoGridPositionsEnum.CERTIF,
					path: userData.verifications.id.photo
				}} />
			{
				hasCertification &&
				<span className={'absolute top-2 right-2'}>
					<BadgeUserCertified forceDisplay />
				</span>
			}
			{
				hasPendingCertification &&
				<span className={'absolute top-2 right-0'}>
					<BadgeUserPendingCertification
						mode='banner'
						forceDisplay />
				</span>
			}
		</div>
	);

};

export default UserPhotoGridCertification;
